import { TagIcon } from '@precon-tools-suite-by-shared/precon-graphql-types';

export type TagIconNamedTheme = 'pi-normal' | 'pi-filled';

export type TagIconTheme = TagIconNamedTheme | TagIconClassMap;

export type TagIconClassMap = Record<TagIcon, string>;
export type TagIconClassMaps = Record<
    TagIconNamedTheme,
    Record<TagIcon, string>
>;

export const piTagIconClassMap: TagIconClassMap = {
    [TagIcon.Asterisk]: 'pi pi-sun',
    [TagIcon.Bookmark]: 'pi pi-bookmark',
    [TagIcon.Box]: 'pi pi-box',
    [TagIcon.Calendar]: 'pi pi-calendar',
    [TagIcon.Clock]: 'pi pi-clock',
    [TagIcon.Cloud]: 'pi pi-cloud',
    [TagIcon.Code]: 'pi pi-code',
    [TagIcon.Database]: 'pi pi-database',
    [TagIcon.File]: 'pi pi-file',
    [TagIcon.Folder]: 'pi pi-folder',
    [TagIcon.Flag]: 'pi pi-flag',
    [TagIcon.Hashtag]: 'pi pi-hashtag',
    [TagIcon.Heart]: 'pi pi-heart',
    [TagIcon.Megaphone]: 'pi pi-megaphone',
    [TagIcon.Star]: 'pi pi-star',
    [TagIcon.Verified]: 'pi pi-verified',
};

export const piFilledTagIconClassMap: TagIconClassMap = {
    ...piTagIconClassMap,
    [TagIcon.Bookmark]: 'pi pi-bookmark-fill',
    [TagIcon.Heart]: 'pi pi-heart-fill',
    [TagIcon.Flag]: 'pi pi-flag-fill',
    [TagIcon.Star]: 'pi pi-star-fill',
};

export const tagIconStyleClassMaps: TagIconClassMaps = {
    'pi-normal': piTagIconClassMap,
    'pi-filled': piFilledTagIconClassMap,
};

export function tagIconToClass(
    icon: TagIcon,
    theme: TagIconTheme = 'pi-normal'
) {
    const classMap: TagIconClassMap =
        typeof theme === 'string' ? tagIconStyleClassMaps[theme] : theme;
    return classMap[icon];
}
